import * as React from 'react'
const GetIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M21.55 11.55h-9.1v-9.1a.44.44 0 00-.13-.32.46.46 0 00-.64 0 .44.44 0 00-.13.32v9.1h-9.1a.44.44 0 00-.32.13.46.46 0 000 .64.44.44 0 00.32.13h9.1v9.1a.44.44 0 00.13.32.46.46 0 00.64 0 .44.44 0 00.13-.32v-9.1h9.1a.44.44 0 00.32-.13.46.46 0 000-.64.44.44 0 00-.32-.13z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default GetIcon